<template lang="html">

  <section class="ficha -observaciones">

    <h2 class="ficha-title" :style="styles.colorBasic">{{$t('observaciones')}}</h2>

    <template v-for="(observacion, key) in observaciones" v-if="observaciones.length > 0">
      <observacion-el :data="observacion"></observacion-el>
    </template>
    
    <template v-if="observaciones.length == 0">
      <p>{{$t('no_tiene_observaciones')}}</p>
    </template>
    

  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import observacion from '@/components/parts/observacion-el';

  
  

  

  export default  {
    name: 'ficha-observaciones',
    props : ['observaciones'],
    data(){
      return{
        
        documentacion : []
      }
    },
    mounted(){

    },
    computed :{
      ...mapGetters({
        styles : 'getStyles',
        documentos :'getDocumentos',
        
      })
    },
    methods : {
    	...mapActions(['dameContestacionEncuesta']),
    },
    components : {
      'observacion-el' : observacion,
    }
  }
</script>

<style scoped lang="scss">
  .ficha.-observaciones {
    .ficha-title{
      margin-top: 5px;

      &.-documentacion-practica{
        margin-top: 20px;
      }
    }

    p{
      text-align: left;
      width: 100%;
      display: inline-block;
      font-size: 14px;
    }

    .add-documentacion{
      cursor: pointer;
      margin-top: 10px;
    }
  }
  


</style>



// WEBPACK FOOTER //
// src/components/views/ficha-observaciones.vue